/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import { InputFieldProps } from "../../types/InputProps";
import { TextField } from "../Textfield";
import InputWrapper from "./InputWrapper";
import styled from "styled-components";

const TextStyle = styled(TextField)`
  input {
    height: 39px;
  }
  label {
    line-height: 2.5;
  }
  .MuiInputLabel-shrink {
    line-height: 1.52;
  }
`;

const formatSsnNumber = (value: string) => {
    const cleaned = value.replace(/\D/g, "").substring(0, 9);
    const match = cleaned.match(/^(\d{3})(\d{2})(\d{0,4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`.replace(/-$/, "");
    }
    return cleaned;
  };
  

export const FormSsnText = (props: InputFieldProps) => {
    const { name, control, info, hint, meta,validations = [] } = props;
  
    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const formattedValue = formatSsnNumber(value || "");
  
          return (
            <InputWrapper info={info} hint={hint} error={error}>
              <FormControl fullWidth>
                <TextStyle
                  error={!!error}
                  value={formattedValue}
                  label={props.label}
                  onChange={(e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 9);
                    const formatted = formatSsnNumber(digitsOnly);
                    onChange(formatted);
                  }}
                  {...meta}
                  onBlur={props.onBlur}
                  autoFocus={props.autoFocus}
                  required={validations.length > 0}
                />
              </FormControl>
            </InputWrapper>
          );
        }}
      />
    );
  };
  
export default FormSsnText;
